import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckoutState } from '@plys/src/application/states/checkout.state';

@Injectable()
export class CheckoutUIService {
  constructor(private checkoutState: CheckoutState, private router: Router, private route: ActivatedRoute) {}

  goNext(relativeToParent = true, replaceUrl = false): void {
    const step = this.checkoutState.goToNextStep();
    if (!step) {
      return;
    }

    this.router.navigate([step.route], {
      relativeTo: relativeToParent ? this.route.parent : this.route,
      queryParamsHandling: 'merge',
      replaceUrl: replaceUrl,
    });
  }

  goPrev(): void {
    const step = this.checkoutState.goToPreviousStep();

    if (!step) {
      return;
    }

    this.router.navigate([step.route], {
      relativeTo: this.route.parent,
      queryParamsHandling: 'merge',
    });
  }

  goToStep(step: string, cartRestart = false): void {
    const restartNavigateConfig = cartRestart ? { queryParams: { cart_id: null }, replaceUrl: true } : {};
    this.router.navigate([step], {
      relativeTo: this.route,
      queryParamsHandling: 'merge',
      replaceUrl: true /* currently goToStep is used only when moving from wrong steps so no need to parametrize */,
      ...restartNavigateConfig,
    });
  }
}
